export const displayedPracticeRoles = (allRoleOptions, person) => {
  const { practiceRoles = [], mainContact } = person;
  const values = [];
  if (mainContact) {
    values.push('Main Contact');
  }

  practiceRoles.forEach((selectedRole) => {
    const matchingRole = allRoleOptions.find(
      (role) => role.value === selectedRole
    );

    if (matchingRole) {
      values.push(matchingRole.label);
    }
  });

  return values.join(', ');
};

export const displayedPermissions = (person) => {
  const { vetPortalViewingPermission, vetPortalAdmin } = person;
  const values = [];
  if (vetPortalAdmin) {
    values.push('Admin');
  }

  const permission = vetPortalPermissionOptions.find(
    (option) => option.value === vetPortalViewingPermission
  );

  values.push(permission.label);

  return values.join(', ');
};

export const vetPortalPermissionOptions = [
  { label: 'None', value: 'none' },
  { label: 'Veterinarian', value: 'vet' },
  { label: 'Account/Practice Owner', value: 'owner' },
];
